import type { ISocialOfferWithFavoriteChallenges } from "@api";
import type { ISocialOffer } from "@bbj-types/offer";

export const isSocialOfferWithFavorite = (
  socialOffer: ISocialOffer
): socialOffer is ISocialOfferWithFavoriteChallenges => {
  return "favoriteChallenges" in socialOffer;
};

export type TOnUpdateOfferWithFavorite = (offer: ISocialOfferWithFavoriteChallenges) => void;
export const isOnUpdateOfferWithFavorite = (
  _offer: ISocialOfferWithFavoriteChallenges,
  onUpdateOffer: unknown
): onUpdateOffer is TOnUpdateOfferWithFavorite => {
  return onUpdateOffer !== undefined;
};
